import { NgModule } from "@angular/core";

import * as Services from './';

@NgModule({
    imports: [
    ],
    exports: [
    ],
    declarations: [
    ],
    providers: [
        Services.ConfigurationService,
        Services.NotificationService,
        Services.HttpService,
        Services.SecurityService,
        Services.SecurityGuard,
        Services.OrderService,
        Services.TeamService,
        Services.PlayerService,
        Services.FixtureService,
        Services.UtilsService,
        Services.StadiumService,
        Services.DrawingsService,
        Services.StateService,
        Services.LogsService,
        Services.AttendanceService,
        Services.NationalTeamService,
        Services.MaintenanceService,
        Services.TournamentService,
    ],
    entryComponents: [
        
    ],
})
export class ServicesModule {
    constructor() { }
}